import { memo } from "react";
import { PanelHeader } from "./PanelHeader";

/**
 * Depth key for the X-RAY lens — makes the underground stack readable:
 * ground plane → buried utilities → MRT tunnel at ~−22 m.
 */
export const XrayLegend = memo(function XrayLegend() {
  return (
    <div className="left-section xray-legend">
      <PanelHeader title="X-RAY · DEPTH KEY" fallbackTier="reference" source="schematic" />
      <p className="caption" style={{ color: "var(--ink-mid)", margin: "0 0 8px" }}>
        Cross-section of Pathumwan under campus. Rows marked (real) are
        measured campus data; (schematic) rows are approximate district
        routing from MWA / BMA / MEA / MRT Blue Line references, not
        surveyed as-built.
      </p>
      <ul className="xray-depth-list">
        <li>
          <span className="xray-swatch" style={{ background: "var(--ink-low)" }} />
          <span className="xray-depth mono">0 m</span>
          <span>Ground plane (faded district)</span>
        </li>
        <li>
          <span className="xray-swatch" style={{ background: "#1F6E43" }} />
          <span className="xray-depth mono">−2 m</span>
          <span>Electricity, campus (real)</span>
        </li>
        <li>
          <span className="xray-swatch" style={{ background: "#38BDF8" }} />
          <span className="xray-depth mono">−3 m</span>
          <span>Water mains, campus + district</span>
        </li>
        <li>
          <span className="xray-swatch" style={{ background: "#10B981" }} />
          <span className="xray-depth mono">−4 m</span>
          <span>Storm drains, campus (real)</span>
        </li>
        <li>
          <span className="xray-swatch" style={{ background: "#6F645A" }} />
          <span className="xray-depth mono">−3 m</span>
          <span>Sewers, district (schematic)</span>
        </li>
        <li>
          <span className="xray-swatch" style={{ background: "#0E7490" }} />
          <span className="xray-depth mono">−2/−4 m</span>
          <span>Storm khlongs + culverts, district (schematic)</span>
        </li>
        <li>
          <span className="xray-swatch" style={{ background: "#506478" }} />
          <span className="xray-depth mono">−22 m</span>
          <span>MRT Blue Line tunnel + stations (schematic)</span>
        </li>
      </ul>
      <p className="caption mono" style={{ color: "var(--ink-low)", marginTop: 8 }}>
        See the layer palette for the full color key, including the amber
        district boundary (on) and the MEA HV/LV cables (off by default).
      </p>
      <p className="caption mono" style={{ color: "var(--ink-low)", marginTop: 8 }}>
        Tip: TopBar cycles 2D → 3D → 3DS. X-RAY auto-enters 3DS so utilities sit under ghosted buildings.
      </p>
    </div>
  );
});
